import { isFunction as c } from "./index575.js";
const m = 100, E = 600, s = "_RepeatClick", p = {
  beforeMount(t, n) {
    const e = n.value, { interval: d = m, delay: l = E } = c(
      e
    ) ? {} : e;
    let o, r;
    const u = () => c(e) ? e() : e.handler(), i = () => {
      r && (clearTimeout(r), r = void 0), o && (clearInterval(o), o = void 0);
    }, a = (v) => {
      v.button === 0 && (i(), u(), document.addEventListener("mouseup", i, { once: !0 }), r = setTimeout(() => {
        o = setInterval(() => {
          u();
        }, d);
      }, l));
    };
    t[s] = { start: a, clear: i }, t.addEventListener("mousedown", a);
  },
  unmounted(t) {
    if (!t[s]) return;
    const { start: n, clear: e } = t[s];
    n && t.removeEventListener("mousedown", n), e && (e(), document.removeEventListener("mouseup", e)), t[s] = null;
  }
};
export {
  E as REPEAT_DELAY,
  m as REPEAT_INTERVAL,
  p as vRepeatClick
};
